import React, { useState, useEffect } from 'react';
import { get, post, put } from '../../services/apiController';
import { TABLE_DEFAULT_LIMIT, DEBOUNCE_DELAY } from '../../util/constant';
import { Table, Modal, Button, Form, FloatingLabel, Row, Col } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import { EditIcon } from '../icons';
import 'react-toastify/dist/ReactToastify.css';
import PaginationInPage from '../Pagination';
import useDebounce from '../useDebounce';
import Company from '../../components/company';
import Factory from '../../components/factory';

const Kitchen = () => {
  const formFields = {
    name: '',
    factoryId: '',
  };
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [kitchenList, setKitchenList] = useState([]);
  const [factories, setFactories] = useState([]);
  const [formDetails, setFormDetails] = useState(formFields);
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  const [filters, setFilters] = useState({ query: '' });

  const handleShow = () => {
    setShowConfirmModel(true);
    setFormDetails(formFields);
  };

  const handleClose = () => {
    setShowConfirmModel(false);
  };

  const handleEdit = (e, id) => {
    e.preventDefault();
    try {
      get('/inv/kitchen/?id=' + id).then((item) => {
        if (item?.data?.rows?.length) {
          const itemData = item.data.rows[0];
          setFormDetails({ ...itemData });
          setShowConfirmModel(true);
        } else {
          toast.error('Invalid id');
        }
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.rows?.message || 'Something went wrong');
    }
  };

  const handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    let _formDetails = { ...formDetails, [name]: value };
    setFormDetails(_formDetails);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if ('id' in formDetails) {
      try {
        await put(formDetails, '/inv/kitchen/' + formDetails.id);
        toast.success('Kitchen updated successfully');
        setShowConfirmModel(false);
        getKitchenDetails();
      } catch (err) {
        toast.error(err?.response?.data?.message || err?.response?.data?.data?.message || err.message, { autoClose: 3000 });
      }
    } else {
      try {
        await post(formDetails, '/inv/kitchen');
        toast.success('Kitchen added successfully');
        setShowConfirmModel(false);
        getKitchenDetails();
      } catch (err) {
        toast.error(err.response.data.message || err.response.data.data.message || err.message, { autoClose: 2000 });
      }
    }
  };

  function getKitchenDetails() {
    try {
      get(`/inv/kitchen/?page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}&query=${filters.query}`).then((response) => {
        setKitchenList(response.data.rows);
        setTotalRecords(response.data.count ?? 0);
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  }

  function getFactories() {
    try {
      get(`/branches/?type=factory`).then((response) => {
        setFactories(response?.data?.rows);
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  }

  useDebounce(
    () => {
      if (currentPage !== 1) {
        setCurrentPage(1);
      } else {
        getKitchenDetails();
      }
    },
    [filters],
    DEBOUNCE_DELAY
  );

  useEffect(() => {
    getKitchenDetails();
  }, [currentPage]);

  useEffect(() => {
    getFactories();
  }, []);

  const handleSelect = (e) => {
    const { value, name } = e.target;
    setFormDetails((state) => {
      return { ...state, [name]: value };
    });
  };

  return (
    <>
      <ToastContainer />
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Kitchens | {totalRecords ?? 0}
          </h4>
          <div className="card-header-actions">
            <Form.Control
              value={filters.query}
              onChange={(e) => setFilters({ ...filters, query: e.target.value })}
              type="search"
              placeholder="Search by name"
              style={{ width: '250px', marginRight: '20px' }}
            />
            <button type="button" className="btn app-btn-default dark-color " onClick={handleShow}>
              Add Kitchen
            </button>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Factory</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {kitchenList.map((item, index) => {
                    return (
                      <tr key={item?.id}>
                        <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                        <td>{item?.name}</td>
                        <td>{item?.Branch?.name}</td>
                        <td className="actions">
                          <span className="edit-icon" onClick={(e) => handleEdit(e, item?.id)}>
                            <EditIcon style={{ color: 'teal' }} />
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal size="lg" show={showConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>{'id' in formDetails ? 'Edit Kitchen' : 'Add Kitchen'}</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
        </Modal.Header>
        <Modal.Body>
          <Form autoComplete="off" onSubmit={handleSubmit}>
            <Row>
              <Col xs={6}>
                <FloatingLabel label="Name" className="mb-3">
                  <Form.Control
                    className="input"
                    name="name"
                    onChange={handleChange}
                    value={formDetails.name}
                    type="text"
                    placeholder="Name"
                    required
                    autoComplete="false"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={6}>
                <FloatingLabel label="Company" className="mb-3">
                  <Company name={'companyId'} label={'Company'} company={1} />
                </FloatingLabel>
              </Col>
              <Col xs={12}>
                <FloatingLabel label="Factory" className="mb-3">
                  <Factory
                    name={'factoryId'}
                    label={'Factory'}
                    factoryId={formDetails.factoryId}
                    onChange={handleSelect}
                    company={1}
                    factories={factories}
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <div className="container text-center">
              <Button type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
                {'id' in formDetails ? 'Update' : 'Add'}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Kitchen;
